export default "__VITE_ASSET__CoP7gGEL__"